module.exports = __webpack_public_path__ + "img/12.3eda9ffe.svg";